//
// Copyright (c) 2011-2024 by Bazaarvoice, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { TableDataSecondaryText } from '@components/atoms/text/Text';

export const UploaderDisclaimer = () => {
  return (
    <DisclaimerContainer>
      <TableDataSecondaryText>
        Disclaimer: Anyone with a link to this media will be able to view it
        once it's uploaded.
      </TableDataSecondaryText>
    </DisclaimerContainer>
  );
};

const DisclaimerContainer = styled.div(
  ({ theme }) => `
  display: flex;
  justify-content: center; /* Centers content horizontally */
  align-items: center; /* Centers content vertically */
  padding: ${theme.spacings[3]} 0;
  margin-bottom:${theme.spacings[4]};
`,
);
